const NitroModal = ({
  id,
  open,
  opaqueBackground,
  style,
  children,
  className,
}: {
  id?: string;
  open: boolean;
  opaqueBackground?: boolean;

  className?: string;
  style: {
    display?: "flex" | "block" | "none";
    width?: number | string;
    maxWidth?: number | string;
    height?: number | string;
    maxHeight?: number | string;
    zIndex?: number;
    justifyContent?: "flex-end" | "center" | "flex-start";
    alignItems?: "flex-end" | "center" | "flex-start";
    flexDirection?: "row" | "column";
    boxShadow?: string;
    borderRadius?: number;
    backgroundColor?: string;
    overflow?: string;
    position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
    top?: number | string;
    bottom?: number | string;
    left?: number | string;
    right?: number | string;
  };
  children: React.ReactElement | React.ReactElement[];
}) => {
  if (!open) return null;

  return (
    <div
      id={id}
      className={className}
      style={{
        backgroundColor: opaqueBackground
          ? "rgba(15, 44, 82, 0.3)"
          : style.backgroundColor,
        width: style.width,
        maxWidth: style.maxWidth,
        height: style.height,
        maxHeight: style.maxHeight,
        display: style.display || "flex",
        flexDirection: style.flexDirection,
        justifyContent: style.justifyContent,
        alignItems: style.alignItems,
        zIndex: style.zIndex || 1,
        boxShadow: style.boxShadow,
        borderRadius: style.borderRadius,
        overflow: style.overflow,
        position: style.position,
        top: style.top,
        bottom: style.bottom,
        left: style.left,
        right: style.right,
      }}
    >
      {children}
    </div>
  );
};

export default NitroModal;
